module.exports = __webpack_public_path__ + "img/unsupported_resolution.f7eca097.png";